"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var theme_1 = __importDefault(require("../utils/theme"));

var icons_1 = __importDefault(require("./icons"));

var getSize = function getSize(size) {
  switch (size) {
    case 'small':
      return {
        height: theme_1.default.size.small,
        width: theme_1.default.size.small
      };

    case 'medium':
      return {
        height: theme_1.default.size.medium,
        width: theme_1.default.size.medium
      };

    case 'large':
      return {
        height: theme_1.default.size.large,
        width: theme_1.default.size.large
      };

    default:
      return {
        height: theme_1.default.size.medium,
        width: theme_1.default.size.medium
      };
  }
};

var Icon = function Icon(_a) {
  var name = _a.name,
      _b = _a.color,
      color = _b === void 0 ? '#000' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c; // @ts-ignore

  var Comp = icons_1.default[name];

  var _d = getSize(size),
      height = _d.height,
      width = _d.width;

  if (Icon !== undefined) {
    return react_1.default.createElement(Comp, {
      width: width,
      height: height,
      fill: color
    });
  }

  return react_1.default.createElement("span", null, "Unable to render: ", name);
};

exports.default = Icon;